import React from 'react';
import { Svg, Path, Rect, Polygon } from 'react-native-svg';

import PropTypes from 'prop-types';

const FintecSystems = ({ width, className, light }) => {
    const logoColor = light ? '#ffffff' : '#0b72b5';
    const textColor = light ? '#ffffff' : '#464748';

    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 841.89 297.28"
            className={className}
            width={width}
        >
            <Path
                d="M98.36,114.31a34.45,34.45,0,1,0,0,68.89c1,0,2,0,3-.13l.47,0-.36-4-.46,0a29.84,29.84,0,0,1-10.07-.8l.9-3.35-.45-.12a27,27,0,0,1-6.5-2.69l-.4-.24-1.74,3a30.62,30.62,0,0,1-10.49-10.49l3-1.74-.23-.4A26.87,26.87,0,0,1,74,137.37l.19-.42L71,135.48a30.25,30.25,0,0,1,11.75-12.82l1.74,3,.4-.24a26.94,26.94,0,0,1,13.47-3.61c.74,0,1.51,0,2.34.11l.47,0,.3-3.46a30,30,0,0,1,9.74,2.68l.42.2,1.71-3.66-.42-.2A34.14,34.14,0,0,0,98.36,114.31Z"
                fill={logoColor}
            />
            <Path
                d="M74.35,77.52A75.91,75.91,0,1,0,149.1,207l.51-.42-5-6-.51.42A68.08,68.08,0,1,1,77,84.88l.62-.22L75,77.3Z"
                fill={logoColor}
            />
            <Path
                d="M134.61,108l4.73-5.64-.48-.4a61,61,0,1,0-78.42,93.45l.49.4,4.73-5.63-.48-.41a53.63,53.63,0,1,1,68.95-82.17Z"
                fill={logoColor}
            />
            <Path
                d="M71.74,109.53a47.69,47.69,0,1,0,58,75.6l.81-.68-3.79-4.52-.81.68a41.79,41.79,0,1,1-50.84-66.25l.87-.61-3.39-4.83Z"
                fill={logoColor}
            />
            <Path
                d="M94.2,133.58a17.36,17.36,0,0,1,21.9,8l.53,1,4.62-2.4-.53-1a22.59,22.59,0,0,0-28.51-10.38,22.46,22.46,0,0,0-5.08,38.57l.92.7,3.17-4.14-.92-.69a17.27,17.27,0,0,1,3.9-29.63Z"
                fill={logoColor}
            />
            <Path
                d="M173.11,204.72H164A84.22,84.22,0,0,1,53.86,218.41c-.5-.34-1-.69-1.46-1s-1.23-.87-1.83-1.32c-.79-.6-1.58-1.22-2.35-1.85l-.77-.62c-.92-.77-1.83-1.56-2.72-2.36l-.2-.18A84.33,84.33,0,0,1,148.38,78.71l.79.54c.84.58,1.66,1.18,2.48,1.79a85.25,85.25,0,0,1,12.93,12,15.22,15.22,0,0,1,5.55-4.14A90.77,90.77,0,0,0,82.89,59.32h-.08c-1.34.28-2.66.59-4,.92l-.64.16c-1.22.32-2.42.67-3.62,1l-.87.26q-1.74.55-3.45,1.17l-.88.33c-1.14.43-2.28.87-3.41,1.35l-.71.3q-1.77.77-3.51,1.59l-.23.12a90.72,90.72,0,0,0-14.66,8.91l-.22.16c-.91.68-1.8,1.39-2.68,2.1-.35.29-.7.56-1,.85q-1.11.93-2.19,1.89c-.48.44-1,.87-1.45,1.32s-1.19,1.12-1.78,1.69-1.22,1.22-1.82,1.84c-.44.46-.89.92-1.33,1.4-.81.87-1.59,1.76-2.37,2.66-.17.21-.36.4-.53.61h0a91.13,91.13,0,0,0,91,147.33l.4-.1c1.5-.36,3-.77,4.47-1.21l1-.3c1.3-.4,2.58-.83,3.85-1.29l.94-.35c1.29-.48,2.58-1,3.85-1.53l.72-.32c1.35-.58,2.69-1.21,4-1.86l.45-.23c1.41-.7,2.8-1.45,4.17-2.23l.2-.11q2.14-1.23,4.23-2.58l.05,0q2.1-1.37,4.13-2.84l.07-.06q1.92-1.39,3.76-2.9l.34-.28c1.05-.86,2.08-1.75,3.1-2.66l.88-.81c.75-.69,1.48-1.39,2.21-2.1.54-.54,1.09-1.09,1.62-1.64s.87-.9,1.29-1.36c.8-.86,1.58-1.74,2.34-2.63.18-.22.38-.42.56-.63h0C171.73,206.43,172.43,205.58,173.11,204.72Z"
                fill={logoColor}
            />
            <Path
                d="M166.71,106.73h0c-2.31,4.08-2.63,9.9-2.63,15.57v12.63h-6.36v10.94h6.36v52.38h11.63V145.87h14.46V134.93H175.71v-11.5c0-10.7,1.59-14,6.84-14h10.72V98.22H182.18C175.52,98.22,169.74,101.4,166.71,106.73Z"
                fill={textColor}
            />
            <Rect x="198.76" y="134.93" width="11.63" height="63.32" fill={textColor} />
            <Polygon
                points="302.72 134.93 292.62 134.93 292.62 114.03 280.99 114.03 280.99 134.93 274.63 134.93 274.63 145.87 280.99 145.87 280.99 198.25 292.62 198.25 292.62 145.87 302.72 145.87 302.72 134.93"
                fill={textColor}
            />
            <Path
                d="M245.15,133.37h-3.26v.13c-13.78,1.22-21.32,10.71-21.32,26.95v37.8H232.2V166.81c0-16.18,3.47-22.19,12.83-22.19,9.9,0,11.83,5.8,11.83,15.83v37.8h11.63v-37.8C268.49,142.52,260.64,133.41,245.15,133.37Z"
                fill={textColor}
            />
            <Path
                d="M420,181.86A20.36,20.36,0,0,1,415,185.8a22.44,22.44,0,0,1-21.78,0,20.66,20.66,0,0,1-7.84-8,22.75,22.75,0,0,1-2.93-11.25,22.12,22.12,0,0,1,6.41-15.94,21,21,0,0,1,30.47,0c.14.14.28.29.41.44l2.94,3.21V138.51a31.74,31.74,0,0,0-18.54-5.57c-9.89,0-17.85,3.49-24.33,10.66a33.89,33.89,0,0,0,.49,45.94c6.15,6.61,14.17,10,23.84,10a32,32,0,0,0,18.54-5.43V178.83Z"
                fill={textColor}
            />
            <Path
                d="M334.39,144.62a20.1,20.1,0,0,0-18.82,14.06h37C350.32,151.32,343.8,144.62,334.39,144.62Z"
                fill="none"
            />
            <Path
                d="M335,188.24a19.23,19.23,0,0,1-20-18.3h49.91l0-3c.08-10-3.28-18.86-9.45-25.08a29.19,29.19,0,0,0-21.24-8.5c-17.65,0-30.95,14.16-30.95,32.94,0,19.23,13,33.19,30.95,33.19,12.54,0,22.66-6.11,28.48-17.2l1.34-2.56H350.81C346.88,185.18,341.28,188.24,335,188.24Zm-.63-43.62c9.41,0,15.93,6.7,18.22,14.06h-37A20.1,20.1,0,0,1,334.39,144.62Z"
                fill={textColor}
            />
            <Path
                d="M478.79,134.16h6.52l27.33,58,24.55-58h6.39l-43,101.54h-6.38l15.4-36.34Z"
                fill={textColor}
            />
            <Path
                d="M760.8,133.42h-1c-9.32.2-15.9,3.86-19.52,10.74-3.43-7.17-9.89-10.72-19.51-10.75h-1c-14.92.32-22.8,9.5-22.8,26.53v38.38h6.2V167c0-14.42,2.12-27.77,17.46-27.77,14.36,0,16.34,10.42,16.35,20.65v38.48h6.21v-32c.06-14.18,2.33-27.15,17.45-27.15C775.09,139.21,777,149.7,777,160v38.38h6.21V160C783.24,142.15,775.9,133.46,760.8,133.42Z"
                fill={textColor}
            />
            <Path
                d="M474.82,179.75c0-23.17-31.65-15.67-31.65-31.07,0,0,0-.09,0-.13v-.44a8,8,0,0,1,3.63-6.74,14.47,14.47,0,0,1,8.62-2.46,22.81,22.81,0,0,1,14.44,5.42V137a26.05,26.05,0,0,0-14.25-4.16c-5.56,0-10.12,1.57-13.56,4.66A13.89,13.89,0,0,0,437,148.58c0,11.45,10.64,15.18,19.12,18.27,6.38,2.22,12.48,4.72,12.48,12.62a14.3,14.3,0,0,1-12.66,14.31l-.41.05c-.31,0-.62,0-.93,0l-.48,0c-6.27,0-12.23-2.84-17.18-8V194a30.11,30.11,0,0,0,14.42,5.57l.24,0,.47,0c.64.05,1.34.09,2.11.09h0c.53,0,1.08,0,1.65-.08C466.54,198.89,474.82,191,474.82,179.75Z"
                fill={textColor}
            />
            <Path
                d="M586.84,179.75c0-23.17-31.65-15.67-31.65-31.07,0,0,0-.09,0-.13s0-.29,0-.44a8,8,0,0,1,3.62-6.74,14.47,14.47,0,0,1,8.62-2.46,22.81,22.81,0,0,1,14.44,5.42V137a26.05,26.05,0,0,0-14.25-4.16c-5.56,0-10.12,1.57-13.56,4.66A13.89,13.89,0,0,0,549,148.58c0,11.45,10.64,15.18,19.12,18.27,6.38,2.22,12.48,4.72,12.48,12.62a14.3,14.3,0,0,1-12.66,14.31l-.41.05c-.31,0-.62,0-.93,0l-.48,0c-6.27,0-12.23-2.84-17.18-8V194a30.11,30.11,0,0,0,14.42,5.57l.24,0,.47,0c.64.05,1.34.09,2.11.09h0c.53,0,1.08,0,1.65-.08C578.57,198.89,586.84,191,586.84,179.75Z"
                fill={textColor}
            />
            <Path
                d="M831.89,179.75c0-23.17-31.66-15.67-31.66-31.07v-.57a8,8,0,0,1,3.63-6.74,14.44,14.44,0,0,1,8.61-2.46,22.82,22.82,0,0,1,14.45,5.42V137a26.08,26.08,0,0,0-14.25-4.16c-5.57,0-10.13,1.57-13.56,4.66a13.89,13.89,0,0,0-5.06,11.06c0,11.45,10.64,15.18,19.11,18.27,6.38,2.22,12.49,4.72,12.49,12.62A14.3,14.3,0,0,1,813,193.78l-.42.05c-.3,0-.62,0-.93,0l-.48,0c-6.27,0-12.22-2.84-17.17-8V194a30.11,30.11,0,0,0,14.42,5.57l.23,0,.48,0c.64.05,1.33.09,2.1.09h0c.53,0,1.08,0,1.64-.08C823.61,198.89,831.89,191,831.89,179.75Z"
                fill={textColor}
            />
            <Path
                d="M608.08,198.34h-6.24V142.65h-7.08v-5.82h7.08V112.75h6.24v24.08h11.24v5.82H608.08Z"
                fill={textColor}
            />
            <Path
                d="M653.82,138.69c-13,0-23.86,10.27-25,22.33h49.38C676.71,149.23,667,138.69,653.82,138.69Z"
                fill="none"
            />
            <Path
                d="M654.51,193.9c-14.84,0-26.08-10.82-25.66-27.05h55.62c.14-18.45-11.37-34-30.79-34-18.73,0-31.07,15.4-31.07,33.3,0,18.17,12.06,33.57,31.07,33.57a31.26,31.26,0,0,0,28.71-17.34h-7.12C670.53,189.31,663.27,193.9,654.51,193.9Zm-.69-55.21c13.18,0,22.89,10.54,24.41,22.33H628.85C630,149,640.78,138.69,653.82,138.69Z"
                fill={textColor}
            />
        </Svg>
    );
};

FintecSystems.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    light: PropTypes.bool,
};

FintecSystems.defaultProps = {
    width: '24px',
    className: '',
    light: false,
};

export default FintecSystems;
